export default __webpack_public_path__ + "static/gallery-9c77360301ed002fc052e9ec1982abbd.jpg";